export const BuildInfo = {timestamp:1787175000000}
